{
  "version": 1,
  "asset_id": "6b1ed080-3e46-451a-af1e-07957d21ccb5",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/6b1ed080-3e46-451a-af1e-07957d21ccb5/sylwia-tvn.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/6b1ed080-3e46-451a-af1e-07957d21ccb5/sylwia-tvn.jpg",
  "original_filename": "sylwia-tvn.jpg",
  "size": 111276,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T07:44:56Z"
}
